<div class="empty-state-wrapper">
  <div class="empty-state-container">
    <div class="image-title-description-wrapper">
      <div class="image-title-description">
        <div *ngIf="imgSrc" class="empty-state-image">
          <img [src]="imgSrc" [style.width]="imgWidth" [style.height]="imgHeight" />
        </div>
        <div *ngIf="title || text" class="empty-state-description mt-9">
          <span *ngIf="title" class="label-base">{{ title }}</span>
          <span *ngIf="text" class="body-text-sm mt-4 main-gray" [innerHTML]="text"></span>
        </div>
      </div>
    </div>
    <div class="empty-state-content mt-9">
      <ng-content></ng-content>
    </div>
  </div>
</div>
